import React from 'react';
import AttachmentListSection from '../AttachmentList';
import { CONSTRUCTOR_REQUEST_ATTACHMENTS } from '../../../Enums/constructors';

const ConstructorAttachmentSection = ({ requestType, ...props }) => {
  const attachmentSetupList = CONSTRUCTOR_REQUEST_ATTACHMENTS[requestType];

  if (attachmentSetupList) {
    return (
      <AttachmentListSection
        {...props}
        attachmentSetupList={attachmentSetupList}
      />
    );
  }

  return <></>;
};

export default ConstructorAttachmentSection;
